/**
 * Fleet permission keys (catalog `fleet.*`, docs/contracts/fleet.md §6). The UI hides what a key does not allow; the API
 * checks the same keys.
 */
export const fleetPermissions = {
  moduleView: "fleet.fleet.view",
  vehicleView: "fleet.vehicle.view",
  vehicleCreate: "fleet.vehicle.create",
  vehicleUpdate: "fleet.vehicle.update",
  vehicleDelete: "fleet.vehicle.delete",
  driverView: "fleet.driver.view",
  driverCreate: "fleet.driver.create",
  driverUpdate: "fleet.driver.update",
  driverDelete: "fleet.driver.delete",
  odometerView: "fleet.odometer.view",
  odometerCreate: "fleet.odometer.create",
  odometerDelete: "fleet.odometer.delete",
  fuelView: "fleet.fuel.view",
  fuelCreate: "fleet.fuel.create",
  fuelUpdate: "fleet.fuel.update",
  fuelPost: "fleet.fuel.post",
  fuelDelete: "fleet.fuel.delete",
  maintenanceView: "fleet.maintenance_order.view",
  maintenanceCreate: "fleet.maintenance_order.create",
  maintenanceUpdate: "fleet.maintenance_order.update",
  maintenancePost: "fleet.maintenance_order.post",
  maintenanceDelete: "fleet.maintenance_order.delete",
  issueCreate: "fleet.issue.create",
  reportView: "fleet.report.view",
  setupView: "fleet.setup.view",
  garageView: "fleet.garage.view",
  carCardView: "fleet.car_card.view",
  carCardCreate: "fleet.car_card.create",
  carCardUpdate: "fleet.car_card.update",
  carCardDelete: "fleet.car_card.delete",
  garageOrderView: "fleet.car_card_order.view",
  garageOrderCreate: "fleet.car_card_order.create",
  garageOrderUpdate: "fleet.car_card_order.update",
  garageOrderPost: "fleet.car_card_order.post",
  garageOrderDelete: "fleet.car_card_order.delete",
  clearanceView: "fleet.clearance_voucher.view",
  clearanceCreate: "fleet.clearance_voucher.create",
  clearanceUpdate: "fleet.clearance_voucher.update",
  clearancePost: "fleet.clearance_voucher.post",
  clearanceDelete: "fleet.clearance_voucher.delete",
} as const;

/** Plan module of the fleet screens (P6). */
export const fleetModule = "fleet";

/** Settings page group of the fleet settings. */
export const fleetSettingsGroup = "fleet";
